<span class="login__view dynamic__padding--md">
    @if (emailConfirmed) {
        <div class="login__title dynamic__stretch--width">
            <span class="dynamic__text dynamic__text--bold login__title__head">Willkommen zurück!</span>
            <span class="dynamic__text--sm">Mit Passwort anmelden</span>
        </div>
    } @else {
        <div class="login__title dynamic__stretch--width">
            <span class="dynamic__text dynamic__text--bold login__title__head">Wie lautet deine E-Mail-Adresse?</span>
            <span class="dynamic__text--sm">Wir prüfen, ob du ein Kundenkonto hast</span>
        </div>
    }

    <form class="login__form" [formGroup]="loginForm" (keydown.enter)="onSubmit()" (ngSubmit)="onSubmit()">
        @if (!emailConfirmed) {
            <div class="login__form__field">
                <input
                    class="login__form__field__input dynamic__text--sm"
                    placeholder="E-Mail"
                    formControlName="email"
                    type="email"
                    [class.login__form__field__input--invalid]="
                        this.loginForm.controls['email'].dirty && this.loginForm.controls['email'].invalid
                    " />
                @if (
                    loginForm.get('email')?.invalid &&
                    (loginForm.get('email')?.dirty || loginForm.get('email')?.touched)
                ) {
                    <div class="dynamic__text--xs login__form__field__error">Ungültige E-Mail</div>
                }
            </div>
        } @else {
            <div class="dynamic__text--sm dynamic__text--bold">
                {{ loginForm.get('email')?.value }}
            </div>

            <div class="login__form__field">
                <input
                    class="login__form__field__input dynamic__text--sm"
                    placeholder="Passwort"
                    formControlName="password"
                    type="password"
                    [class.login__form__field__input--invalid]="
                        this.loginForm.controls['password'].dirty && this.loginForm.controls['password'].invalid
                    " />
                @if (
                    loginForm.get('password')?.invalid &&
                    (loginForm.get('password')?.dirty || loginForm.get('password')?.touched)
                ) {
                    <div class="dynamic__text--xs login__form__field__error">
                        @if (loginForm.get('password')?.errors?.['required']) {
                            <div>Ungültiges Passwort</div>
                        }

                        @if (loginForm.get('password')?.errors?.['minlength']) {
                            <div>Ungültiges Passwort (min. 6 Zeichnen)</div>
                        }

                        @if (loginForm.get('password')?.errors?.['serverError']) {
                            {{ loginForm.get('password')?.errors?.['serverError'] }}
                        }
                    </div>
                }
            </div>
        }

        @if (emailConfirmed) {
            <button
                class="dynamic__button dynamic__stretch--width"
                type="submit"
                [class.dynamic__button--disabled]="loginForm.invalid"
                [disabled]="loginForm.invalid">
                Mit Passwort anmelden
            </button>
        } @else {
            <button
                class="dynamic__button dynamic__stretch--width"
                [class.dynamic__button--disabled]="loginForm.get('email')?.invalid"
                [disabled]="loginForm.get('email')?.invalid"
                (click)="confirmEmail()">
                Weiter
            </button>
        }
    </form>
</span>
